import slice from './slice';

export const {
    loadJobs, loadJobsFailed, addJob, removeJob, reset, setJob, updateLocalJobState,
    updateDisplayedCompoundJobs, setJobState, updateDisplayedScreeningJobs,
    updateDisplayedFreeEnergyJobs, updateDisplayedMdJobs,
} = slice.actions;
export default slice.reducer;
